export const Lista_Restricciones_Alimenticias = [
    "Ninguna",
    "Vegetariano (Sí como huevos, lacteos)",
    "Vegano (No come huevos o lacteos)",
    "Otra"
] as const;